import { MarketplaceV1 } from '@jebel/constants';
import { formatMoneyFromCents } from './money';
/**
 * Formats a product's price and frequency into a human-readable string.
 *
 * @param product - The product or subscription to format.
 * @returns A formatted string like "$10.00 - Annual" or "$10.00" (if no frequency).
 */
export function formatCommunityProductPrice(product) {
    const priceLabel = formatMoneyFromCents(product.priceCents);
    if (product.frequency === MarketplaceV1.CommunitySubscriptionFrequency.Annual) {
        return `${priceLabel}/yr`;
    }
    return priceLabel;
}
